var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_720_2637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9273 20.7478V11.9478H19.6273V20.7478H11.0273V25.1478H19.6273V33.9478H23.9273V25.1478H32.5273V20.7478H23.9273ZM21.7773 44.9478C16.0752 44.9478 10.6066 42.6299 6.57455 38.5041C2.54252 34.3783 0.277344 28.7825 0.277344 22.9478C0.277344 17.113 2.54252 11.5172 6.57455 7.3914C10.6066 3.2656 16.0752 0.947754 21.7773 0.947754C27.4795 0.947754 32.9481 3.2656 36.9801 7.3914C41.0122 11.5172 43.2773 17.113 43.2773 22.9478C43.2773 28.7825 41.0122 34.3783 36.9801 38.5041C32.9481 42.6299 27.4795 44.9478 21.7773 44.9478Z",
    fill: "#949494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_720_2637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 44,
    fill: "white",
    transform: "translate(0.277344 0.947754)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.e094fdd29af36968776afc432fd5f723.svg";
export { ForwardRef as ReactComponent };